module.exports = __webpack_public_path__ + "resources/img/img_sqml_di2_m.357e3844a37faf3eafe1da412cb6c6fd.png";